// Compose item data for GA4 add_to_cart event to leverage the GA4 e-commerce reports.

import type Product from '@modules/product/type/product';
import type Variant from '@modules/product/type/variant';

type ProductProps = Pick<Product, 'ID' | 'Title'>;

// This is mirrored in themes/archipro2/javascript/react/helpers/ga4/helpers.ts
// make sure they are always in sync
interface GA4ProductProps {
    product: ProductProps;
    selectedVariant?: Variant | null;
    quantity: number;
}

/**
 * product data for GA4 ecommerce event.
 * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#add_to_cart_item
 */
export interface GA4ProductData {
    item_id: string | number;
    item_name: string;
    item_variant?: string | number;
    index?: number; // index of the item in the list
    item_brand?: string;
    item_category?: string;
    item_category2?: string;
    item_category3?: string;
    item_category4?: string;
    item_category5?: string;
    price?: string | number;
    quantity?: number;
}

// https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#add_to_cart
export const getProductGA4Data = (props: GA4ProductProps) => {
    const { product, selectedVariant, quantity } = props;
    const priceData = selectedVariant?.Price;
    const price = priceData?.Amount
        ? (priceData?.Amount / 100.0).toFixed(2)
        : 0;
    const currency = priceData?.Currency;
    return {
        currency: currency,
        value: price,
        items: [
            {
                item_id: product.ID,
                item_name: product.Title,
                item_variant: selectedVariant?.ID,
                price,
                quantity,
            },
        ],
    };
};
